import React from "react";
import { motion } from "framer-motion";
import { REGIONS, segments } from "./chainData";

const OUTLINE = [
  "M120 20 a26 26 0 1 1 -0.1 0 Z",
  "M110 76 L110 96 M130 76 L130 96",
  "M110 96 C92 98 78 100 70 108 C62 118 60 140 58 170 C56 200 52 236 50 272",
  "M130 96 C148 98 162 100 170 108 C178 118 180 140 182 170 C184 200 188 236 190 272",
  "M80 120 C82 160 86 196 88 224 C86 236 84 246 86 258 L154 258 C156 246 154 236 152 224 C154 196 158 160 160 120",
  "M86 258 C90 300 94 336 96 370 C96 404 96 440 96 470 L80 492 L104 492 L106 470",
  "M154 258 C150 300 146 336 144 370 C144 404 144 440 144 470 L160 492 L136 492 L134 470",
  "M120 258 L118 300",
];

function Hotspot({ id, point, lit, active, onSelect }) {
  const [x, y] = point;
  return (
    <g
      role="button"
      tabIndex={0}
      aria-label={REGIONS[id].name}
      className="cursor-pointer focus:outline-none"
      onClick={() => onSelect?.(id)}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onSelect?.(id); } }}
    >
      <circle cx={x} cy={y} r={16} fill="transparent" />
      {active && (
        <motion.circle cx={x} cy={y} r={8} fill="none" stroke="#C5A880" strokeWidth={1.2}
          initial={{ r: 8, opacity: 0.9 }} animate={{ r: 18, opacity: 0 }} transition={{ duration: 1.6, repeat: Infinity }} />
      )}
      <circle cx={x} cy={y} r={active ? 7 : lit ? 5.5 : 4}
        className="transition-all duration-500"
        fill={lit || active ? "#C5A880" : "#FAF7F2"}
        stroke={lit || active ? "#A3865E" : "#2A2421"} strokeOpacity={lit || active ? 1 : 0.45} strokeWidth={1.2} />
    </g>
  );
}

// Minimal line-art body with clickable regions and animated connection lines.
export function BodyFigure({ lit = [], active, pairs = [], spine = false, onSelect, testid = "body-figure" }) {
  return (
    <svg viewBox="0 0 240 520" className="w-full h-auto max-h-[70vh]" data-testid={testid} role="img" aria-label="Interactive body chain map">
      <g fill="none" stroke="#2A2421" strokeOpacity={0.28} strokeWidth={1.1} strokeLinecap="round" strokeLinejoin="round">
        {OUTLINE.map((d) => <path key={d} d={d} />)}
      </g>
      <line x1={120} y1={74} x2={120} y2={252} stroke={spine ? "#C5A880" : "#2A2421"} strokeOpacity={spine ? 0.9 : 0.15}
        strokeWidth={spine ? 2 : 1} strokeDasharray="2 5" className="transition-all duration-700" />
      {pairs.map(([a, b]) => segments(a, b).map(([p, q]) => (
        <motion.line key={`${a}-${b}-${p[0]}-${q[0]}`} x1={p[0]} y1={p[1]} x2={q[0]} y2={q[1]}
          stroke="#C5A880" strokeWidth={1.6} strokeLinecap="round"
          initial={{ pathLength: 0, opacity: 0 }} animate={{ pathLength: 1, opacity: 1 }} transition={{ duration: 0.7, ease: "easeOut" }} />
      )))}
      {Object.keys(REGIONS).map((id) => REGIONS[id].points.map((pt) => (
        <Hotspot key={`${id}-${pt[0]}`} id={id} point={pt} lit={lit.includes(id)} active={active === id} onSelect={onSelect} />
      )))}
    </svg>
  );
}
